export default "https://cdn-static.gokick.com/assets/45a1ec4753cb63ac9804059da02cc099817f84d7/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";